import { render, staticRenderFns } from "./DoublePicker.vue?vue&type=template&id=8bd4db1e&scoped=true&"
import script from "./DoublePicker.vue?vue&type=script&lang=js&"
export * from "./DoublePicker.vue?vue&type=script&lang=js&"
import style0 from "./DoublePicker.vue?vue&type=style&index=0&id=8bd4db1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4db1e",
  null
  
)

export default component.exports